import * as tslib_1 from "tslib";
import { Type } from 'class-transformer';
import { UserDashboardItemResultDto } from './user-dashboard-item-result-dto';
const ɵ0 = () => UserDashboardItemResultDto;
export class UserDashboardResultDto {
    get actualOpen() {
        return Math.max(0, this.open - this.priority - this.problematic);
    }
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", Array)
], UserDashboardResultDto.prototype, "items", void 0);
export { ɵ0 };
